import React from 'react';
import PropTypes from 'prop-types';

const Lock = ({ fill = '', ...props }) => (
  <svg
    {...props}
    width="36"
    height="44"
    viewBox="0 0 36 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.0001 0C12.0266 0 7.16675 4.85983 7.16675 10.8333V17.3333H5.00008C3.85081 17.3333 2.74861 17.7899 1.93595 18.6025C1.12329 19.4152 0.666748 20.5174 0.666748 21.6667V39C0.666748 40.1493 1.12329 41.2515 1.93595 42.0641C2.74861 42.8768 3.85081 43.3333 5.00008 43.3333H31.0001C32.1494 43.3333 33.2515 42.8768 34.0642 42.0641C34.8769 41.2515 35.3334 40.1493 35.3334 39V21.6667C35.3334 20.5174 34.8769 19.4152 34.0642 18.6025C33.2515 17.7899 32.1494 17.3333 31.0001 17.3333H28.8334V10.8333C28.8334 4.85983 23.9736 0 18.0001 0ZM11.5001 10.8333C11.5001 7.24967 14.4164 4.33333 18.0001 4.33333C21.5837 4.33333 24.5001 7.24967 24.5001 10.8333V17.3333H11.5001V10.8333ZM20.1667 34.0665V39H15.8334V34.0665C15.0759 33.6327 14.4677 32.9795 14.0889 32.1931C13.7101 31.4067 13.5785 30.5239 13.7116 29.6612C13.8446 28.7985 14.236 27.9963 14.8341 27.3605C15.4322 26.7247 16.2089 26.2851 17.0619 26.0997C17.6955 25.9596 18.3524 25.9635 18.9843 26.1111C19.6161 26.2587 20.2068 26.5463 20.7127 26.9526C21.2186 27.3589 21.6269 27.8736 21.9074 28.4587C22.1879 29.0439 22.3335 29.6845 22.3334 30.3333C22.3322 31.0911 22.1312 31.8352 21.7509 32.4906C21.3705 33.146 20.8241 33.6895 20.1667 34.0665Z"
      fill={fill || '#2B2D42'}
    />
  </svg>
);

Lock.propTypes = {
  fill: PropTypes.string,
};

export default Lock;
